module.exports = __webpack_public_path__ + "static/media/ios-download.14c804cf.png";